import React, { useEffect, useState } from "react";
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError, showConfirmation, showSuccess } from "../../services/alert";

const PropriedadeList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/propriedades");
      setRows(res.data || []);
    } catch (err) {
      showError("Erro ao buscar propriedades.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleDelete = async (id) => {
    const ok = await showConfirmation({
      title: "Excluir propriedade?",
      text: "Tem certeza que deseja excluir este registro?",
      confirmText: "Sim, excluir",
      cancelText: "Cancelar",
    });
    if (!ok) return;

    try {
      await api.delete(`/propriedades/${id}`);
      showSuccess("Excluído com sucesso.");
      fetchData();
    } catch (err) {
      showError(err?.response?.data?.message || "Erro ao excluir.");
    }
  };

  const columns = [
    { name: "Nome", selector: r => r.nome, sortable: true },
    { name: "Área (ha)", selector: r => r.areaHa, sortable: true, right: true, width: "140px" },
    {
      name: "Localização",
      selector: r => r.cidade ? `${r.cidade}${r.estado ? ` - ${r.estado}` : ""}` : "Não informada",
      sortable: true,
      wrap: true,
      cell: r => <div><span>{r.cidade ? `${r.cidade}${r.estado ? ` - ${r.estado}` : ""}` : "Não informada"}</span>{r.latitude && r.longitude && <a className="d-block small text-success" href={`https://www.openstreetmap.org/?mlat=${r.latitude}&mlon=${r.longitude}#map=15/${r.latitude}/${r.longitude}`} target="_blank" rel="noreferrer"><i className="bi bi-map me-1" />Ver no mapa</a>}</div>,
    },
    { name: "Agricultor", selector: r => r.agricultorNome || "-", sortable: true, wrap: true },
    { name: "Ativo", selector: r => (r.ativo ? "Sim" : "Não"), sortable: true, width: "120px" },
    {
      name: "Ações",
      cell: row => (
        <div className="d-flex gap-1">
          <button className="btn btn-outline-success btn-sm d-flex align-items-center gap-1" onClick={() => navigate(`/propriedades/editar/${row.id}`)}>
            <i className="bi bi-pencil-square" />
            <span>Editar</span>
          </button>
          <button className="btn btn-outline-danger btn-sm d-flex align-items-center gap-1" onClick={() => handleDelete(row.id)}>
            <i className="bi bi-trash" />
            <span>Excluir</span>
          </button>
        </div>
      ),
      ignoreRowClick: true, allowOverflow: true, button: true, minWidth: "160px", style: { whiteSpace: "nowrap" },
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button className="btn btn-light btn-sm d-flex align-items-center gap-1" onClick={() => navigate("/menu")}>
              <i className="bi bi-arrow-left text-success" />
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Propriedades</h5>
              <small className="text-white-50">Gerencie as propriedades</small>
            </div>
          </div>
          <button className="btn btn-light text-success fw-bold d-flex align-items-center gap-1" onClick={() => navigate("/propriedades/novo")}>
            <i className="bi bi-plus-circle" />
            <span>Nova Propriedade</span>
          </button>
        </div>

        <div className="card-body">
          <DataTable
            columns={columns}
            data={rows}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma propriedade encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default PropriedadeList;
